export default __webpack_public_path__ + "static/media/loading.706124a2.gif";